import React, { useEffect } from 'react'
import Loading from '../../Components/Common/NewLoading';
import { useDispatch, useSelector } from 'react-redux';
import FullscreenRoundedIcon from '@mui/icons-material/FullscreenRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { getSlotGameData } from '../../store/actions/casino.actions';
import { Translate } from '../../localization';

const SingleGame = () => {
const dispatch =useDispatch()
    const { currentGameData } = useSelector((state) => state.casino);
    const history = useHistory();
    const { gameTitle } = useParams()
    useEffect(() => {
        if (!currentGameData?.url)
        {
            const game = {"game_id":gameTitle}
            dispatch(getSlotGameData(game, "demo", history));
        }
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.setAttribute(
                'href',
                `https://www.jackpotct.com/${Translate.getLanguage()}/d/casino/game/${gameTitle}`
            );
        }
    }, []);

    const myStyles = {
        fontSize: '15px',
        fontWeight: 'bold',
        textTransform: 'capitalize',
        marginLeft: '0px',
        padding: '0px',
      };

    useEffect(() => {
        document.title = `${gameTitle.replace("-", " ")} Casino Game - JackpotCT`;
        const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `Play this intersting ${gameTitle}  online casino game
        and test your skills in strategic gameplay. Win big with thrilling bets`
      );
    }

      }, []);

    const openFullscreen = () => {
        let elem = document.getElementById("casino__iframe");
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    };

    return (
        <div id='scrollableDiv' className='position-relative'>
            <h1 style={myStyles} className='game-name-haeding'>{gameTitle.replace("-", " ")}</h1>
            {currentGameData?.url ? (
                <>
                <div className='home-header'>

                </div>
                <div className='d-flex justify-content-center'>
                    <iframe
                        className="casino__iframe"
                        id='casino__iframe'
                        src={`${currentGameData.url}`}
                        title="Casino Game"
                        allowFullScreen
                    ></iframe>
                    <div className='iframe-btn-box'>
                        <button className='iframe-btn' onClick={() => openFullscreen()}>
                            <FullscreenRoundedIcon/>
                        </button>
                        <NavLink className='iframe-btn' to={`/${Translate.getLanguage()}/d/casino`}>
                            <CloseRoundedIcon/>
                        </NavLink>
                    </div>
                </div>
                </>
            ) : (
                <Loading />
            )}
        </div>
    );
};

export default SingleGame;
